import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function Usage(props) {
    const opened = props.opened || !!props.usageValue;
    const usageTranslationKey = FilterLabelTranslationKeys[Filters.USAGE];
    const unavailableUsages = (TYROOLA.initialFluxStates.filter.unavailableUsages) ? TYROOLA.initialFluxStates.filter.unavailableUsages:[];
    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline="catalog-filters-section-headline-usage"
            containerModifier="usage"
        >
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-usage-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.USAGE}
                    value={props.usageValue}
                    options={props.usageOptions}
                    labelTranslationKey={usageTranslationKey}
                    provideAllTranslationKey="catalog-filters-usage-select-label-all"
                    onChange={props.onUsageChange}
                    onToolTipHover={() => props.onToolTipHover('Usage')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.usageValue}
                    unavailableOptions = {unavailableUsages}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

Usage.propTypes = {
    usageValue: PropTypes.string.isRequired,
    usageOptions: PropTypes.array.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onUsageChange: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
};

export { Usage };
